$(document).ready(function () {
  let sizeIds = {};
  let sizePrice = {};

  $(".btn-primary.AddToCart").each(function () {
    const btnAtc = $(this);
    const productId = btnAtc.attr("id").split("_")[1];
    const btnId = btnAtc.attr("id");
    const sizeSelector = $(`#size-selector_${productId}`);

    // Prevent form submission if no flavor is selected
    btnAtc.on("click", function (event) {
      const form = btnAtc.closest("form");
      // Optionally, remove the other input values based on the button clicked
      console.log("btnId", btnId);
      if (btnId === `subs_${productId}`) {
        let dataInput = $(`input#selling_plan_${productId}`).data(
          "selling-plan-id"
        );
        $(`#size_variant_id_${productId}`).val(dataInput);
      } else if (btnId === `once_${productId}`) {
        $(`#size_variant_id_${productId}`).val("");
      }
    });

    sizeSelector.on("change", function () {
      sizeIds = {};

      $(`input.once-product-variants_${productId}`).map(function () {
        let title = $(this).data("variant-title");
        let id = $(this).data("variant-id");
        let price = $(this).data("variant-price");

        if (title && id) {
          sizeIds[title] = id;
        }

        if (price && id) {
          sizePrice[id] = price;
        }
      });
      if (sizeSelector.val()) {
        let searchVar = sizeSelector.val();
        updateSize(searchVar, productId);
      }
    });
  });
  function getValue(obj, key) {
    return obj[key];
  }
  function updateSize(searchTerm, productId) {
    const MatchId = findId(searchTerm);
    const MatchPrice = getValue(sizePrice, MatchId);

    if (MatchId) {
      $(`#variant_id_${productId}`).val(MatchId);
    }
    if (MatchPrice) {
      let formattedPrice = Shopify.formatMoney(+MatchPrice, "${{amount}}");
      let discountPrice = Shopify.formatMoney(
        +MatchPrice * 0.75,
        "${{amount}}"
      );
      console.log("discountPrice", discountPrice);
      $(".btn__price.once" + productId).text(formattedPrice);
      $(".btn__price.subs" + productId).text(discountPrice);
    }
  }

  function findId(searchTerm) {
    // Create a case-insensitive regular expression
    const regex = new RegExp(searchTerm, "i");

    // Iterate over the variantIds object
    for (const [key, value] of Object.entries(sizeIds)) {
      if (regex.test(key)) {
        return value; // Return the ID of the first matching key
      }
    }

    return null; // Return null if no match is found
  }
});
